import React from "react";
import { fenceLengthM } from "../../lib/helpers";

// Fence name (+ optional length) labels rendered upright at each polyline centroid.
export default function FenceLabels({ elements, ppm, zoom, rot, canSeeDetails }) {
  const z = zoom || 1;
  const fences = elements.filter((el) => el.kind === "fence" && el.points && el.points.length >= 2);
  return fences.map((el) => {
    const cx = el.points.reduce((s, p) => s + p.x, 0) / el.points.length;
    const cy = el.points.reduce((s, p) => s + p.y, 0) / el.points.length;
    const len = fenceLengthM(el.points, ppm);
    const small = el.fence_size === "small";
    return (
      <div key={`fence-lbl-${el.id}`}
        style={{
          position: "absolute", left: cx, top: cy,
          transform: `translate(-50%, -50%) scale(${1 / z}) rotate(${-(rot || 0)}deg)`,
          transformOrigin: "center", display: "flex", flexDirection: "column", alignItems: "center",
          pointerEvents: "none", whiteSpace: "nowrap", padding: "1px 6px", borderRadius: 3,
          background: small ? "rgba(154,52,18,0.85)" : "rgba(153,27,27,0.85)",
        }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#FFFFFF", lineHeight: 1.15, textShadow: "0 1px 2px rgba(0,0,0,0.95)" }}>
          {el.name}
        </span>
        {canSeeDetails && (
          <span className="font-mono-data" style={{ fontSize: 9, color: small ? "#FFEAD6" : "#FFE0E0", textShadow: "0 1px 2px rgba(0,0,0,0.95)" }}>
            {len.toFixed(1)} m
          </span>
        )}
      </div>
    );
  });
}
